import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { EditableProperty } from './EditableProperty';

export const EditableReminderConfigProperty = ({
  config,
  patchField,
  handleChange,
  placeholder,
  editFormatter,
  labelFormatter,
  ...rest
}) => (
  <EditableProperty
    dto={config}
    changeHandler={handleChange}
    patchField={patchField}
    placeholder={placeholder}
    targetUrl={`${process.env.REACT_APP_TASK_SERVICE_URL}/reminder/config`}
    editFormatter={editFormatter}
    labelFormatter={labelFormatter}
    {...rest}
  />
);

EditableReminderConfigProperty.propTypes = {
  config: PropTypes.shape({
    profileId: PropTypes.number.isRequired,
  }).isRequired,
  placeholder: PropTypes.string,
  editFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
};
